import { render, staticRenderFns } from "./SingleTours.vue?vue&type=template&id=1399eaac&"
import script from "./SingleTours.vue?vue&type=script&lang=js&"
export * from "./SingleTours.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports